export default __webpack_public_path__ + "static/media/upgrade-report6.881ab6b0.png";